import React from "react";
import DistributionAllocationMethodsFields from "./DistributionAllocationMethodsFields";
import DistributionsOptionsFormFields from "./DistributionsOptionsFormFields";
import FeesFields from "./FeesFields";
import SourceApplicableTable from "./SourceApplicableTable";
import { AddHierarchy, LoanDocumentCard } from "../../../components";

const SeparationFromService = (props) => {
  const { isSave, isEdit, fields } = props;

  return (
    <div>
      <DistributionsOptionsFormFields {...props} />
      <SourceApplicableTable {...props} />
      <DistributionAllocationMethodsFields {...props} />
      <FeesFields {...props} />
      <LoanDocumentCard
        {...props}
        fields={fields}
        isEdit={isEdit}
        isSave={isSave}
        fieldArrayName={fields.withdrawalDocumentType}
      />

      <AddHierarchy {...props} />
    </div>
  );
};

export default SeparationFromService;
